

export class AppointmentNotesModel{
    id:number;
    appointmentId:number;
    createdOn:Date;
    note:string;
    createdBy:number;
    updatedOn:Date;
    updatedBy:number;

}